export const MUTATION_GROUP = 'labelsFields' as const;
